import React, { useState } from 'react'
import { injectIntl } from 'react-intl'
import { Tooltip } from 'reactstrap'
import IntlMessages from '../../../helpers/IntlMessages'
import { undoPhrase, rephraseSentence } from './utils'

const RephraseTools = (props) => {
  const [tooltipOpenRephrase, setTooltipOpenRephrase] = useState(false)
  const [tooltipOpenUndo, setTooltipOpenUndo] = useState(false)
  const {
    editorOriginal, editorParaphrased, paraphrases, setParaphrases, setSynonymsRephrase
  } = props

  const toggleTooltipRephrase = () => { setTooltipOpenRephrase(!tooltipOpenRephrase) }
  const toggleTooltipUndo = () => { setTooltipOpenUndo(!tooltipOpenUndo) }

  return (
    <div className="rephrase-tools d-none">
      <button
        id="rephrase"
        className="btn btn-empty p-3"
        type="button"
        onClick={() => {
          rephraseSentence(editorOriginal, editorParaphrased, paraphrases, setParaphrases, setSynonymsRephrase)
        }}
      >
        <i className="fal fa-redo-alt d-block" />
      </button>
      <button
        id="undo"
        className="btn btn-empty p-3"
        type="button"
        onClick={() => { undoPhrase(editorOriginal, editorParaphrased) }}
      >
        <i className="fal fa-eraser d-block" />
      </button>
      <Tooltip
        placement="left"
        isOpen={tooltipOpenRephrase}
        target="rephrase"
        toggle={toggleTooltipRephrase}
      >
        <IntlMessages id="Rephrase" />
      </Tooltip>
      <Tooltip
        placement="left"
        isOpen={tooltipOpenUndo}
        target="undo"
        toggle={toggleTooltipUndo}
      >
        <IntlMessages id="OriginalSentence" />
      </Tooltip>
    </div>
  )
}

export default injectIntl(RephraseTools)
